import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import {
  ConciergeItemType,
  ConciergeType,
} from "../../controller/ConciergeController";
import ApiController from "../../controller/ApiController";
import { authState, masterStoreState } from "../../recoil/auth";
import { getConciergeName } from "../../utils/util";
import { useToast } from "../../controller/ToastController";
import { showKeyboardState } from "../../recoil/showKeyboard";
import LogController from "../../controller/LogController";
import { visibleConciergeState } from "../../recoil/modal";

const ConciergeModal = (oProps: {
  concierge: ConciergeType;
  resetTimer: () => void;
}) => {
  const [isVisible, setVisible] = useRecoilState<boolean>(
    visibleConciergeState
  );

  const lang = useRecoilValue(langState);
  const [type, setType] = useState<number[]>([]);
  const [content, setContent] = useState<string>("");

  const [onKeyboard, setOnKeyboard] = useState<boolean>(false);

  const showToast = useToast();
  const [showKeyboard, setShowKeyboard] = useRecoilState(showKeyboardState);
  const auth = useRecoilValue(authState);
  const master = useRecoilValue(masterStoreState);

  const textareaRef = useRef<any>(null);

  const onCloseModal = () => {
    setVisible(false);
  };

  const selectType = (itemId: number) => {
    if (type.includes(itemId)) {
      const newType = type.filter((item) => item !== itemId);
      setType([...newType]);
    } else {
      const newType = [...type];
      newType.push(itemId);
      setType([...newType]);
    }
  };

  // 컨시어지 요청
  const sendConciergeList = async () => {
    try {
      if (master) {
        const oParams = {
          store_id: master.store_id,
          user_token_id: auth.user_token_id,
          user_id: auth.user_id,
          concierge_list_id_list: type,
          request_content: content,
          lang: lang,
        };
        const response = await ApiController.concierge.sendConciergeList(
          oParams
        );
        console.log("sendConciergeList", response);

        if (response && response.data) {
          if (response.status === 200) {
            setVisible(false);
            showToast(langText.confirmModal_title[lang]);
            LogController.event({
              path: "ConciergeModal",
              params: "concierge",
              params2: `${JSON.stringify(type)} 컨시어지 요청 완료`,
              index: master.store_id,
            });
          } else {
            showToast(response.data.msg, "error");
          }
        }
      }
    } catch (err) {
      console.log("sendConciergeList err-->", err);
      LogController.api({
        path: "ConciergeModal",
        params: "concierge",
        params2: `concierge/sendConciergeList 실패`,
      });
    }
  };

  useEffect(() => {
    setType([]);
    setContent("");
  }, [isVisible]);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (textarea) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [content]);

  // useEffect(() => {
  //   if (!showKeyboard.showKeyboard) {
  //     setContent(showKeyboard.input);
  //   }
  // }, [showKeyboard.showKeyboard]);

  useEffect(() => {
    setContent(showKeyboard.input);
  }, [showKeyboard.input]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: `conciergeModal ${onKeyboard && "input"}`,
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div
          className="modal"
          onTouchStart={oProps.resetTimer}
          onScrollCapture={oProps.resetTimer}
        >
          <div className="modal_header">
            <div className="cleckButton">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clerk.svg`}
                width={40}
                height={40}
                alt="ic"
              />
            </div>
            <h6>{langText.conciergeModal_title[lang]}</h6>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="ic"
            />
          </div>
          <div className="modal_content">
            <div className="typeListWrap">
              {oProps.concierge?.concierge_list &&
                oProps.concierge.concierge_list.length > 0 &&
                oProps.concierge.concierge_list.map(
                  (item: ConciergeItemType, index: number) => {
                    return (
                      <button
                        key={index}
                        className={`typeButton ${
                          type.includes(item.concierge_list_id) && "active"
                        }`}
                        onClick={() => selectType(item.concierge_list_id)}
                      >
                        <img
                          src={item.file_url}
                          alt={`concierge${item.concierge_list_id}`}
                        />
                        {getConciergeName(item, lang)}
                      </button>
                    );
                  }
                )}
            </div>
            {lang === 0 ? (
              <textarea
                ref={textareaRef}
                value={content}
                placeholder={langText.conciergeModal_placeholder[lang]}
                onChange={(e) => setContent(e.target.value)}
                onFocus={() => setOnKeyboard(true)}
                onBlur={() => setOnKeyboard(false)}
              />
            ) : (
              <div
                ref={textareaRef}
                onClick={() =>
                  setShowKeyboard((prev) => ({
                    ...prev,
                    showKeyboard: true,
                    input: content,
                  }))
                }
                className="textarea"
              >
                {content || langText.conciergeModal_placeholder[lang]}
              </div>
            )}
            <button className="submitButton" onClick={sendConciergeList}>
              {langText.conciergeModal_button_submit[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ConciergeModal;

const Style = styled.div`
  .modal {
    width: 100%;
    height: 100%;
    padding: 8% 5%;
  }

  .modal_header {
    width: 100%;
    min-height: 200px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 3% 0 6% 0;

    h6 {
      font-size: 24px;
      line-height: 36px;
      color: #ffffff;
    }

    .closeIcon {
      position: absolute;
      top: -20%;
      right: -2%;
      cursor: pointer;
    }
  }
  .modal_content {
    width: 100%;
    height: 75%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

  .typeListWrap {
    width: 100%;
    display: flex;
    align-items: center;
    overflow-x: auto;
    gap: 1.5%;
    .typeButton {
      min-width: 22%;
      max-width: 22%;
      aspect-ratio: 1/1;
      margin: 0.75% 0;
      background: #343434;
      border: 2px solid #e5e5e5;
      border-radius: 5px;
      font-size: 18px;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: pre-line;
      gap: 10px;
      touch-action: auto;
    }
    .typeButton.active {
      background: #40977f;
    }
    img {
      width: 66px;
      height: 66px;
      object-fit: contain;
    }
  }

  textarea,
  .textarea {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    height: 240px;
    max-height: 18dvh;
    background: #555555;
    color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 300;
    outline-color: #4dd2ae;
    white-space: pre-wrap;
    word-break: break-all;
    overflow: auto;
  }
  .textarea {
    align-items: flex-start;
    word-wrap: break-word;
  }
  .cleckButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    background: #4dd2ae;
    border-radius: 100px;
    cursor: pointer;
    z-index: 100;
  }

  .submitButton {
    margin-top: 10px;
    width: 100%;
    padding: 18px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }
`;
